<section class="members-card">
  <div class="card-header members-header">
    <div>
      <h2 class="eyebrow">Project Users</h2>
      <p>
        Search workspace users, assign project roles, and keep your collaborator
        list up to date.
      </p>
    </div>
    <div class="members-header-actions">
      <span class="metric-note">
        {{ memberCount() }} {{ memberCount() === 1 ? "member" : "members" }}
      </span>
      <button
        type="button"
        class="btn btn-primary add-user-button"
        (click)="onAddUserClick()"
        [disabled]="loading() || addingUser()"
      >
        @if (addingUser()) {
          <span
            class="spinner-border spinner-border-sm me-2"
            aria-hidden="true"
          ></span>
        } @else {
          <i class="bi bi-person-plus me-2" aria-hidden="true"></i>
        }
        Add user
      </button>
    </div>
  </div>

  @if (error()) {
    <div class="alert alert-danger mb-0">{{ error() }}</div>
  }
  @if (loading()) {
    <div class="members-state">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p>Loading project users...</p>
    </div>
  } @else if (!members().length) {
    <div class="members-state">
      <div class="state-icon">
        <i class="bi bi-people"></i>
      </div>
      <h3>No project users yet</h3>
      <p>Add a workspace user to start collaborating on this project.</p>
      <button
        type="button"
        class="btn btn-primary add-user-button"
        (click)="onAddUserClick()"
        [disabled]="addingUser()"
      >
        <i class="bi bi-person-plus me-2" aria-hidden="true"></i>
        Add user
      </button>
    </div>
  } @else {
    <div class="table-shell">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th scope="col">User</th>
              <th scope="col">Email</th>
              <th scope="col">Role</th>
              <th scope="col" class="text-end">
                <span class="visually-hidden">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (member of members(); track member.projectUser.id) {
              <tr>
                <td>
                  <div class="member-cell">
                    <span class="member-avatar">
                      @if (member.user?.profilePictureUrl) {
                        <img
                          [src]="member.user?.profilePictureUrl"
                          [alt]="getDisplayName(member.user)"
                        />
                      } @else {
                        <span>{{ getUserInitials(member.user) }}</span>
                      }
                    </span>

                    <div>
                      <div class="member-name">
                        {{ getDisplayName(member.user) }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="member-email">
                  {{ getUserSecondaryText(member.user) }}
                </td>
                <td>
                  <div class="role-select-wrap">
                    <select
                      class="form-select form-select-sm role-select"
                      [ngModel]="member.projectUser.role"
                      (ngModelChange)="updateProjectUserRole(member, $event)"
                      [disabled]="isMemberBusy(member)"
                    >
                      @for (role of userRoles(); track role) {
                        <option [ngValue]="role">{{ formatRole(role) }}</option>
                      }
                    </select>
                    <i
                      class="bi bi-chevron-down role-select-caret"
                      aria-hidden="true"
                    ></i>
                  </div>
                </td>
                <td class="text-end">
                  <div class="member-actions">
                    @if (isMemberBusy(member)) {
                      <span
                        class="spinner-border spinner-border-sm member-action-spinner"
                        role="status"
                      >
                        <span class="visually-hidden">Updating…</span>
                      </span>
                    } @else {
                      <button
                        type="button"
                        class="member-action member-action--remove"
                        [title]="'Remove ' + getDisplayName(member.user)"
                        [attr.aria-label]="
                          'Remove ' + getDisplayName(member.user)
                        "
                        (click)="onRemoveUserClick(member)"
                      >
                        <i class="bi bi-x-lg" aria-hidden="true"></i>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</section>
